var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1945"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 56",
    fill: "currentColor",
    stroke: "#d0d5db"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.65 11.65)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 51",
    cx: 1.483,
    cy: 1.483,
    r: 1.483,
    transform: "translate(7.648 17.382)",
    fill: "#1f2a3b"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 52",
    cx: 1.483,
    cy: 1.483,
    r: 1.483,
    transform: "translate(16.128 17.382)",
    fill: "#1f2a3b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2189",
    d: "M.993.996h3.8l2.551 12.665a1.9 1.9 0 0 0 1.9 1.523h9.241a1.9 1.9 0 0 0 1.9-1.523l1.32-9.145H6.214",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2189 - Outline",
    d: "M18.523 15.829H9.25a2.54 2.54 0 0 1-2.537-2.041L4.27 1.641H.993a.646.646 0 0 1 0-1.291H4.8a.643.643 0 0 1 .63.518L6.034 3.9a.64.64 0 0 1 .179-.025h15.494a.645.645 0 0 1 .636.738l-1.32 9.145q0 .017-.006.034a2.54 2.54 0 0 1-2.494 2.037Zm-9.278-1.291h9.278a1.254 1.254 0 0 0 1.231-.989l1.211-8.387H6.289l1.684 8.371a1.255 1.255 0 0 0 1.259 1.005Z",
    fill: "#1f2a3b"
  })))));
};
export default SvgCart;